<div
  class="alert alert-danger d-flex align-items-center p-2"
  [class.clickable]="emitClickOnWholeElement()"
  role="alert"
  (click)="outerSelected($event)"
>
  <span class="mts-icon notranslate mx-2 error-icon" translate="no">error</span>
  <div class="fs-verysmall">
    {{ message() }}
    @if (linkText()) {
      <app-link (click)="selected($event)" [title]="linkText()" [style]="'alert'" [noPadding]="true">{{ linkText() }}</app-link>
    }
  </div>
</div>
